import { Bar, BarChart, CartesianGrid, LabelList, Tooltip, XAxis, YAxis } from "recharts";
import { formatCompactCurrency, formatCurrency } from "@/lib/calculators";
import { ARR_TREND } from "./exampleData";
import {
  BORDER,
  CHART_POSITIVE,
  MUTED_FG,
  tooltipStyle,
  xAxisProps,
  yAxisProps,
} from "./chartTheme";
import MetricChartFrame from "./MetricChartFrame";

/**
 * Total ARR by month — annualised MRR, the same book viewed at yearly scale.
 * The app's positive green, climbing to the example's $300,000.
 */
const ArrChart = () => (
  <MetricChartFrame
    caption="ARR is simply MRR × 12 — the same recurring book at annual scale, climbing from $240,000 to $300,000 as the underlying MRR grows."
    chartType="Line"
    breakdown="No breakdown"
    active="6M"
  >
    <BarChart data={ARR_TREND} margin={{ top: 16, right: 8, left: 8, bottom: 0 }}>
      <CartesianGrid strokeDasharray="3 3" stroke={BORDER} vertical={false} />
      <XAxis dataKey="label" {...xAxisProps} />
      <YAxis tickFormatter={(v) => formatCompactCurrency(Number(v))} width={56} {...yAxisProps} />
      <Tooltip
        cursor={{ fill: "hsl(var(--muted) / 0.4)" }}
        contentStyle={tooltipStyle}
        formatter={(value: number) => [formatCurrency(value), "ARR"]}
      />
      <Bar dataKey="value" fill={CHART_POSITIVE} radius={[4, 4, 0, 0]} isAnimationActive={false}>
        <LabelList
          dataKey="value"
          position="top"
          formatter={(v: number) => formatCompactCurrency(Number(v))}
          fontSize={11}
          fill={MUTED_FG}
        />
      </Bar>
    </BarChart>
  </MetricChartFrame>
);

export default ArrChart;
